// @flow
import * as React from "react";

type Props = {
  messages: { [key: string]: string },
  component: React.ComponentType<{ message: string }>,
};

function MessageList({ messages, component: Component }: Props): React.Node {
  const messageKeys = Object.keys(messages);

  if (messageKeys.length === 0) return null;

  return messageKeys.map((key, index) => {
    return <Component key={index} message={messages[key]} />;
  });
}

export default MessageList;
